import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* The periods and their dates are the very same ones the page of the records is looked at by */
import { PERIODS, periodDates } from "../booking"

registerLocale("ru", ru)
moment.locale("ru")
Modal.setAppElement("#root")


/* The panel opens on the current month */
export const INITIAL_FILTER = { period: "month", ...periodDates("month") }


/* HOW MANY VALUES of the filter differ from the empty one — the button of the page shows it */
export const filterCount = filter => (filter.period === INITIAL_FILTER.period ? 0 : 1)


/* WHAT THE PERIOD IS CALLED — the header says the name of the period and the dates under it,
   so an own period is called by its words and never by the dates themselves */
export const periodName = filter => {

    const period = PERIODS.find(item => item.key === filter.period)

    return period ? period.text : "Свой период"
}


/* Widget Filter Modal — the dashboard is looked at over a period and nothing else, so the
   window of the filters carries the dates alone. It is opened by the reference:
   this._filter.current.open(filter) */
class FilterModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            filter: { ...INITIAL_FILTER }
        }
    }

    /* Open the filter on what the page is showing now */
    open = filter => {
        this.setState({ visible: true, filter: { ...INITIAL_FILTER, ...filter } })
    }

    /* Close the filter */
    close = () => {
        this.setState({ visible: false })
    }

    /* Choose the period — its dates are filled in at once */
    period = key => {

        /* The own period keeps the dates which are already chosen */
        if (key === "period") {
            this.setState(previous => ({ filter: { ...previous.filter, period: key } }))
            return
        }

        this.setState(previous => ({ filter: { ...previous.filter, period: key, ...periodDates(key) } }))
    }

    /* Give the chosen period to the page */
    apply = () => {

        const { filter } = this.state
        const { onApply } = this.props

        this.setState({ visible: false })
        onApply(filter)
    }

    /* Drop everything back to the current month */
    reset = () => {

        const { onApply } = this.props

        this.setState({ visible: false, filter: { ...INITIAL_FILTER } })
        onApply({ ...INITIAL_FILTER })
    }

    render = () => {

        /* Fields */
        const { visible, filter } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="filter-modal"
                overlayClassName="filter-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="filter-modal-header">
                    <h2>Период</h2>
                    <div onClick={this.close} className="filter-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="filter-modal-body">

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Готовый период</div>

                        <div className="filter-modal-chips">
                            {PERIODS.map(period =>
                                <div
                                    key={period.key}
                                    onClick={() => this.period(period.key)}
                                    className={`filter-modal-chip ${filter.period === period.key ? "active" : ""}`}
                                >
                                    {period.text}
                                </div>
                            )}
                        </div>

                        <div className="filter-modal-dates">

                            <div className="filter-modal-date">
                                <span>С</span>
                                <DatePicker
                                    withPortal
                                    portalId="datepicker-portal"
                                    locale="ru"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filter.startDate}
                                    onChange={date => this.setState(previous => ({ filter: { ...previous.filter, period: "period", startDate: date } }))}
                                />
                            </div>

                            <div className="filter-modal-date">
                                <span>По</span>
                                <DatePicker
                                    withPortal
                                    portalId="datepicker-portal"
                                    locale="ru"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filter.endDate}
                                    onChange={date => this.setState(previous => ({ filter: { ...previous.filter, period: "period", endDate: date } }))}
                                />
                            </div>

                        </div>

                    </div>

                </div>

                <div className="filter-modal-footer">
                    <div onClick={() => this.reset()} className="filter-modal-button light">Сбросить</div>
                    <div onClick={() => this.apply()} className="filter-modal-button">Показать</div>
                </div>

            </Modal>
        )
    }
}

export default FilterModal
